import React from 'react';

const Financeiro = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">
        Módulo Financeiro
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">Custos por Viagem</h3>
          <p className="text-gray-600 mb-4">Análise de custos operacionais</p>
          <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors">
            Acessar
          </button>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">Relatórios</h3>
          <p className="text-gray-600 mb-4">Indicadores financeiros</p>
          <button className="w-full bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors">
            Acessar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Financeiro;
